export default __webpack_public_path__ + "static/286-a6c83d16a086fbf550725c67acb8cb3c.gif";